import { Link } from "supercell-frontend-base/src/components/article/navigation/link";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";

import { getArticleIndex } from "supercell-frontend-base/src/utils/articles/get-article-index";
import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { handleThumbnail } from "supercell-frontend-base/src/utils/articles/get-article-thumbnail";
import { BoomBeachGameParams } from "../../validation/game-params";

type ArticleData = {
    articles: InboxArticle[];
    globals: Record<string, string>;
};

const isOnNewsTab = (article: InboxArticle) => article.type === "newsEntry";

export const getProps =
    (id: string, isolated: boolean, gameParams: BoomBeachGameParams) =>
    ({ articles, globals }: ArticleData) => {
        const newsArticles = articles.filter(isOnNewsTab);

        const validArticles = newsArticles.filter((e: InboxArticle) =>
            filterEntry(e, gameParams),
        );

        const index = getArticleIndex(validArticles, id);
        const article = validArticles[index];

        const nextPrevArticles = validArticles.filter(
            (e: InboxArticle) => e.showInNewsFeed !== "HIDE_IN_NEWS_FEED",
        );
        const nextPrevArticlesIndex = getArticleIndex(nextPrevArticles, id);
        const prevArticle = nextPrevArticles[nextPrevArticlesIndex + 1];
        const nextArticle = nextPrevArticles[nextPrevArticlesIndex - 1];

        const prevLinkProps =
            !isolated && prevArticle
                ? {
                      LabelComponent: ListArticle,
                      labelComponentProps: {
                          data: {
                              ...handleThumbnail(prevArticle, "face"),
                              listingSize: "small",
                              newUntil: 0,
                              categories: [
                                  { title: globals["globalText.langPrevious"] },
                              ],
                          },
                      },
                  }
                : undefined;

        const nextLinkProps =
            !isolated && nextArticle
                ? {
                      next: true,
                      LabelComponent: ListArticle,
                      labelComponentProps: {
                          data: {
                              ...handleThumbnail(nextArticle, "face"),
                              listingSize: "small",
                              newUntil: 0,
                              categories: [
                                  { title: globals["globalText.langNext"] },
                              ],
                          },
                      },
                  }
                : undefined;

        return {
            article,
            Link,
            prevLinkProps,
            nextLinkProps,
        };
    };
